import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ideas",
  "description": "",
  "published": "2007-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/ideas/swizec/335"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Somewhere around midday today I had a wonderful idea for a blog post, but it managed to drown in the sea of maths that was filling my head at the time. So I was really struggling to find an idea about what to blog. Then in chat someone mentioned pancakes and immediately my mind frolicked as it thought pancakes are a trully awesome device and should be blogged about.`}</p>
    <p>{`But instead of that I decided to blog about ideas. Because what exactly is an idea? What is it about a certain thought that makes the owner go `}<em parentName="p">{`Hey, that was an idea`}</em>{` it makes little logical sense. Or why is it that some ideas are good and some aren't, but then again that's not very hard to answer. What `}<strong parentName="p">{`is`}</strong>{` hard to answer, though, is where ideas come from.`}</p>
    <p>{`Many artists believe they have a so called Muse in their possession that comes up with good ideas for them. But does it really? Does it really do anything more than sit around on its arse and look at you while you sweat for ideas? The answer is, no, no it does not. The Muse is just a good excuse to blame somebody else for one's own success because in the long term everyone fears being responsible for themselves, it would mean there is no faith, no god, no nothing, just little old unimportant us.`}</p>
    <p>{`I realise this post lacks a punchline, but my Muse went to the toilet.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      